import axios from 'axios'
import { history } from './history'

const baseUrl = 'https://petrocard.sabinarya.com/api/v1/'
// const baseUrl = 'https://petrotest.sabinarya.com/api/v1/'
// const baseUrl = 'http://172.16.20.90:4040/api/v1/'

const get = async url => {
    const result = await axios.get(baseUrl + url,{
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
        }
    })
    if(result && result.data && result.data.statusCode == 6){
        localStorage.removeItem('token')
        history.navigate('/')
    }
    return result
}
const post = async (url,postedData = {}) => {
    const result = await axios.post(baseUrl + url,postedData,{
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
        }
    })
    if(result && result.data && result.data.statusCode == 6){
        localStorage.removeItem('token')
        history.navigate('/')
    }
    return result
}

export {
    get,
    post
}